export const GENERATION_LABELS: Record<number, { fr: string; en: string }> = {
  1: { fr: 'Kanto', en: 'Kanto' },
  2: { fr: 'Johto', en: 'Johto' },
  3: { fr: 'Hoenn', en: 'Hoenn' },
  4: { fr: 'Sinnoh', en: 'Sinnoh' },
  5: { fr: 'Unys', en: 'Unova' },
  6: { fr: 'Kalos', en: 'Kalos' },
  7: { fr: 'Alola', en: 'Alola' },
  8: { fr: 'Galar', en: 'Galar' },
  9: { fr: 'Paldea', en: 'Paldea' },
}

export function getGenerationLabel(
  generation: number,
  t: (fr: string, en: string) => string,
  fallback = 'Unknown',
): string {
  const label = GENERATION_LABELS[generation]
  if (!label) return fallback
  return t(label.fr, label.en)
}
